module.exports = __webpack_public_path__ + "img/fenpei.3bedb20c.png";